import { render, staticRenderFns } from "./CardCompanies.vue?vue&type=template&id=88a32fac&scoped=true&"
import script from "./CardCompanies.vue?vue&type=script&lang=js&"
export * from "./CardCompanies.vue?vue&type=script&lang=js&"
import style0 from "./CardCompanies.vue?vue&type=style&index=0&id=88a32fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a32fac",
  null
  
)

export default component.exports